import { render, staticRenderFns } from "./ComponentChanger.vue?vue&type=template&id=37f796d2"
import script from "./ComponentChanger.vue?vue&type=script&lang=js"
export * from "./ComponentChanger.vue?vue&type=script&lang=js"
import style0 from "./ComponentChanger.vue?vue&type=style&index=0&id=37f796d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports